module.exports = __webpack_public_path__ + "img/banner-plan-artwork.6c36c19c.png";